module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/bg_mv-301a9988a74c696f9692f6037eaa17c9.png";